import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import useHelpModal from 'components/HelpModal/useHelpModal';
import { URLS } from 'config';

export interface ContainerComponentChildrenArgs {
  onClick: () => void;
  showHelpModal: () => void;
}

export interface ContainerComponentProps {
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
}

const ContainerComponent = ({ children }: ContainerComponentProps) => {
  const { length, goBack, push } = useHistory();
  const { showHelpModal } = useHelpModal();

  const onClick = useCallback(() => {
    if (length === 0) {
      push(URLS.home);
      return;
    }
    goBack();
  }, [length, goBack, push]);

  return children({ onClick, showHelpModal });
};

ContainerComponent.displayName = 'MyAccount-container';

export default ContainerComponent;
